import React from 'react';
import PropTypes from 'prop-types';
import {MenuItem, SelectField} from "material-ui";

const EMPTY_EDITOR_CONTENT = '<div>&nbsp;</div>';

class PluginConfiguration extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        enableSave: PropTypes.func,
        disableSave: PropTypes.func
    };

    static defaultProps = {
        configuration: null
    };

    constructor(props) {
        super(props);

        this.htmlTemplateEditorElm = null;
        this.tinymceEditor = null;

        this.tinymceInitCallback = this.tinymceInitCallback.bind(this);
        this.onTemplateTypeChange = this.onTemplateTypeChange.bind(this);

        let templateType = (props.configuration && props.configuration.templateType) || 'handlebars';

        this.state = {
            templateType: templateType,
            tinymceInitialized: false
        };
    }

    getConfiguration() {
        let template = this.tinymceEditor.getContent();
        return {
            templateType: this.state.templateType,
            template: template
        };
    }

    componentDidMount() {
        this.loadTinyMCEScript().then(() => {
            this.initTinyMCE();
        });
    }

    componentWillUnmount() {
        if (this.tinymceEditor) {
            this.destroyEditor();
        }
    }

    loadTinyMCEScript() {
        let id = "tinymceScript";
        let src = "https://app.tasksharp.com/js/tinymce/tinymce.min.js";

        if (document.getElementById(id) !== null) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.id = id;
            script.type = "text/javascript";
            script.src = src;
            script.addEventListener('load', () => {
                resolve();
            });
            script.addEventListener('error', (err) => {
                reject(err);
            });

            let head = document.head || document.getElementsByTagName("head")[0];
            head.appendChild(script);
        });
    }

    initTinyMCE() {
        window.tinymce.init({
            target: this.htmlTemplateEditorElm,
            // focus the editor when it renders
            auto_focus: 'htmlTemplateEditor',
            theme: 'modern',
            init_instance_callback: this.tinymceInitCallback,
            menu: {
                edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
                view: {title: 'View', items: 'visualaid preview'},
                format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'}
            },
            // plugins needed for several toolbar button to work
            plugins: 'textcolor lists advlist link code fullscreen preview paste',
            toolbar: 'fontselect fontsizeselect styleselect | bold italic underline forecolor backcolor ' +
            '| alignleft aligncenter alignright alignjustify bullist numlist outdent indent ' +
            '| link code fullscreen | removeformat',
            fontsize_formats: '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
            // hide status bar
            statusbar: false,
            // hide "Powered by tinymce"
            branding: false,
            // use HTML4 schema as we will use the content for emails which should be as compatible as possible
            schema: 'html5',
            // tinymce wraps all root text nodes with <p> tags, change them to <div>
            forced_root_block: 'div'
        });
    }

    tinymceInitCallback(editor) {
        this.tinymceEditor = editor;
        if (this.props.configuration && this.props.configuration.template) {
            this.tinymceEditor.setContent(this.props.configuration.template);
        }
        this.tinymceEditor.on('Change', () => {
            if (editor.getContent() === EMPTY_EDITOR_CONTENT) {
                this.props.disableSave();
            } else {
                this.props.enableSave();
            }
        });
        this.tinymceEditor.on('Remove', () => {
            this.htmlTemplateEditorElm = null;
            this.tinymceEditor = null;
        });
        this.setState({
            tinymceInitialized: true
        });
    }

    destroyEditor() {
        this.tinymceEditor.destroy();
    }

    onTemplateTypeChange(event, index, templateType) {
        this.setState({templateType: templateType});
    }

    renderTemplateTypeSelectField() {
        if (!this.state.tinymceInitialized) {
            return null;
        }
        return (
            <SelectField
                className="custom-field custom-select-field"
                fullWidth={false}
                floatingLabelFixed={true}
                floatingLabelText="Template Engine"
                hintText="Choose template engine"
                value={this.state.templateType}
                onChange={this.onTemplateTypeChange}
            >
                <MenuItem value={"handlebars"} primaryText="Handlebars" />
                <MenuItem value={"mustache"} primaryText="Mustache" />
            </SelectField>
        );
    }

    render() {
        let loading = this.state.tinymceInitialized ? null : <div>Loading</div>;
        return (
            <div>
                {loading}
                {this.renderTemplateTypeSelectField()}
                <div id="htmlTemplateEditor" style={{height: 400}} ref={elm => {this.htmlTemplateEditorElm = elm;}}/>
            </div>
        );
    }
}

export default PluginConfiguration;



// WEBPACK FOOTER //
// ./src/components/plugins/htmlTemplatePlugin/PluginConfiguration.js